import SectionHeader from "../components/SectionHeader";
import CTASection from "../components/CTASection";
import { STEPS } from "../lib/business";
import { ClipboardList, MessagesSquare, CalendarCheck2 } from "lucide-react";

const ICONS = [ClipboardList, MessagesSquare, CalendarCheck2];

export default function HowItWorksPage() {
  return (
    <div data-testid="how-it-works-page">
      <section className="bg-secondary/60 border-b border-border">
        <div className="container-x py-14 sm:py-20">
          <SectionHeader
            eyebrow="How It Works"
            title="How It Works"
            subtitle="Getting help with your home project should be simple, clear, and stress-free."
          />
        </div>
      </section>
      <section className="section-y">
        <div className="container-x">
          <ol className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {STEPS.map((step, i) => {
              const Icon = ICONS[i];
              return (
                <li key={step.n} data-testid={`how-step-${step.n}`} className="bg-white border border-border rounded-2xl p-7 card-elevate flex flex-col">
                  <div className="flex items-center gap-3">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-accent">
                      <Icon size={22} />
                    </span>
                    <span className="text-4xl font-extrabold text-accent/40">{step.n}</span>
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-primary">{step.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{step.desc}</p>
                </li>
              );
            })}
          </ol>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
